var map = {
	"./404.svg": "oUrx",
	"./bug.svg": "F3lI",
	"./chart.svg": "yCkv",
	"./clipboard.svg": "vDVG",
	"./component.svg": "VtY+",
	"./dashboard.svg": "94Jb",
	"./documentation.svg": "kPu2",
	"./drag.svg": "m7++",
	"./edit.svg": "qkZ8",
	"./email.svg": "y7eQ",
	"./example.svg": "MMMJ",
	"./excel.svg": "ZZmv",
	"./exit-fullscreen.svg": "28eg",
	"./eye-open.svg": "1+ww",
	"./eye.svg": "TfVu",
	"./form.svg": "6xvN",
	"./fullscreen.svg": "mSHS",
	"./guide 2.svg": "ICep",
	"./guide.svg": "ZoO1",
	"./icon.svg": "nZHn",
	"./international.svg": "F9+T",
	"./language.svg": "JYDz",
	"./link.svg": "GPBF",
	"./list.svg": "MokB",
	"./lock.svg": "qwAt",
	"./message.svg": "R/8a",
	"./money.svg": "MEYL",
	"./nested.svg": "3PhE",
	"./password.svg": "Kj24",
	"./pdf.svg": "+aF5",
	"./people.svg": "0Fbn",
	"./peoples.svg": "LxGF",
	"./qq.svg": "FDDl",
	"./search.svg": "jo2x",
	"./settings.svg": "P8iQ",
	"./shopping.svg": "EqXK",
	"./size.svg": "hkRB",
	"./star.svg": "cIpu",
	"./tab.svg": "j7e1",
	"./table.svg": "R/Hx",
	"./theme.svg": "5TQQ",
	"./tiptap-add_col_after.svg": "cBj6",
	"./tiptap-add_col_before.svg": "2QTO",
	"./tiptap-add_row_after.svg": "ec3N",
	"./tiptap-add_row_before.svg": "7x1v",
	"./tiptap-bold.svg": "dSKK",
	"./tiptap-checklist.svg": "8L8/",
	"./tiptap-code.svg": "taZh",
	"./tiptap-combine_cells.svg": "8CrX",
	"./tiptap-delete_col.svg": "LjVp",
	"./tiptap-delete_row.svg": "ENUZ",
	"./tiptap-delete_table.svg": "Dza5",
	"./tiptap-github.svg": "nIMs",
	"./tiptap-hr.svg": "kCbn",
	"./tiptap-image.svg": "iprT",
	"./tiptap-italic.svg": "hRv2",
	"./tiptap-link.svg": "l3nR",
	"./tiptap-mention.svg": "sjxz",
	"./tiptap-ol.svg": "j6nr",
	"./tiptap-paragraph.svg": "igzo",
	"./tiptap-quote.svg": "swuu",
	"./tiptap-redo.svg": "me7H",
	"./tiptap-remove.svg": "NgVs",
	"./tiptap-strike.svg": "kUWf",
	"./tiptap-table.svg": "6S0t",
	"./tiptap-ul.svg": "kGAI",
	"./tiptap-underline.svg": "wfO2",
	"./tiptap-undo.svg": "kpiL",
	"./tree.svg": "k80C",
	"./user.svg": "s7Vf",
	"./wechat.svg": "gNoN",
	"./zip.svg": "iqZD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";